import { createAction } from "redux-actions";
import type { NavbarItem } from "./NavbarLayout";

const menuClicked = createAction("MENU_CLICKED", (item: NavbarItem) => ({
  menu: item.label,
  to: item.to,
}));

export { menuClicked };
